export class DashboardViewModel {
    TotalFinalized: number;
    DailyDistributions: DailyDistribution[];
    HourlyDistributions: HourlyDistribution[];
    ModalityDistributions: ModalityDistribution[];
    ExamDistributions: ExamDistribution[];
    RadiologistModalityDistributions: RadiologistModalityDistribution[];
}

export class ModalityDistribution {
    ItemName: string;
    TotalStudyCount: number;
}

export class DailyDistribution {
    DayName: string;
    DayNo: number;
    TotalStudyCount: number;
}

export class HourlyDistribution {
    HourlyNo: number;
    TotalStudyCount: number;
}

export class ExamDistribution {
    ItemName: string;
    TotalStudyCount: number;
}
export class RadiologistModalityDistribution {
    RadiologistName: string;
    ItemName: string;
    TotalStudyCount: number;
}
